import React, {useState, useEffect} from 'react';

import { Link, useHistory, useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';

import { verify } from '../services/LogIn';
import { setIsLoggedIn } from '../store/app';

export default function VerifySignUp() {
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const dispatch = useDispatch();
  const is_logged_in = useSelector(state => state.app.is_logged_in);
  const {code} = useParams();
  const history = useHistory();

  useEffect(() => {
    if (is_logged_in) {
      history.push("/");
    }
  }, [is_logged_in, history]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password !== password2){
      window.alert("Your password entries did not match each other.");
      return;
    }
    verify(code, password)
    .then(response => {
      if (response.success) {
        window.alert("Your account has been created!");
        if (response.is_demo) {
          history.push("/demo_instructions");
        }
        // App fetches the account's data once logged in.
        dispatch(setIsLoggedIn(true));
      } else if (response.error) {
        window.alert(response.error);
      }
    });
  };

  return (
    <>

     <div className="row text-center pt-5 mt-5">
        <div className="col-12">
          <h1 className="font-weight-bold">Let's get <span className="text-danger">started.</span></h1>
          <p>Your contact information has been verified.  To complete your account, create a password below.<br/>Passwords
            must have at least one of: lowercase letter, uppercase letter, number, and symbol.</p>
        </div>
      </div>
    <Form id="signup" className="row mx-3 d-flex justify-content-center" onSubmit={handleSubmit}>
      <div className="col-12 col-md-6 mx-auto bg-white shadow rounded py-3 m-3 m-sm-0">
        <Form.Group className="col-12 mb-3">
          <Form.Label>Password</Form.Label>
          <Form.Control type="password" className="pr-password" onChange={(e) => setPassword(e.target.value)} value={password}/>
        </Form.Group>
        <Form.Group className="col-12 mb-3">
          <Form.Label>Re-enter password</Form.Label>
          <Form.Control type="password" onChange={(e) => setPassword2(e.target.value)} value={password2}/>
        </Form.Group>
        <div className="col-12">
          <Button type="submit" variant="danger btn-lg w-100 text-uppercase">Start using Linkoln</Button>
        </div>
      </div>
    </Form>
        <p className="text-center text-body"><small>Already signed up? <Link to="/log_in" className="text-reset"><u>Login here</u></Link></small></p>
    </>
  );
}
